import { Input } from "antd";
import classNames from "classnames";
import PropTypes from "prop-types";
import { useState } from "react";
import { MdCheck, MdPriorityHigh, MdLock } from "react-icons/md";
import Label from "shared/components/Label";
import {
  filterTextField,
  normalizeTextField,
  stripTrailingSpaces,
} from "utils/helpers/validations";

const { TextArea } = Input;

const Textarea = ({
  label,
  placeholder,
  errors,
  touched,
  icon,
  required,
  optional,
  success,
  showSuccessIcon = true,
  className,
  normalizeText = false,
  onChange,
  onBlur,
  value: valueProp,
  defaultValue,
  ...rest
}) => {
  const [val, setVal] = useState(defaultValue ?? "");
  const isControlled = valueProp !== undefined;
  const useInternalState = normalizeText && !isControlled;
  const displayValue = useInternalState ? val : (valueProp ?? defaultValue);

  const hasValue =
    displayValue !== undefined &&
    displayValue !== null &&
    `${displayValue}`.trim() !== "";

  const handleChange = (e) => {
    let value = e.target.value;
    if (normalizeText) value = filterTextField(value);
    e.target.value = value;
    if (useInternalState) setVal(value);
    onChange?.({ ...e, target: { ...e.target, value } });
  };

  const handleBlur = (e) => {
    let value = e.target.value;
    if (normalizeText) value = normalizeTextField(value);
    value = stripTrailingSpaces(value);
    if (value !== e.target.value) {
      e.target.value = value;
      if (useInternalState) setVal(value);
      onChange?.({ ...e, target: { ...e.target, value } });
    }
    onBlur?.(e);
  };

  const textareaProps = {
    ...(normalizeText
      ? {
          value: displayValue,
          onChange: handleChange,
        }
      : {
          onChange,
          ...(valueProp !== undefined ? { value: valueProp } : {}),
          ...(defaultValue !== undefined ? { defaultValue } : {}),
        }),
    onBlur: handleBlur,
  };

  return (
    <div
      className={classNames("input__wrapper", {
        __error: touched && errors,
        __success: success && !errors,
      })}
    >
      <Label
        label={label}
        icon={icon}
        required={required}
        optional={optional}
      />
      <div className={`input__wrapper--field`}>
        <TextArea
          className={classNames(className, {
            "input--borderd--red": touched && errors,
            "disable--input": rest.disabled,
            "input--filled": hasValue,
          })}
          placeholder={placeholder}
          {...textareaProps}
          {...rest}
        />

        {touched && errors && (
          <MdPriorityHigh className="input--error-icon" size={20} />
        )}

        {success && showSuccessIcon && !errors && (
          <MdCheck className="input--success-icon" size={20} />
        )}

        {rest.disabled && !touched && (
          <MdLock className="input--disabled-icon" size={16} />
        )}
      </div>
      {touched && errors && <p className={"input--errors"}>{errors}</p>}
    </div>
  );
};

Textarea.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  errors: PropTypes.string,
  touched: PropTypes.bool,
  icon: PropTypes.node,
  required: PropTypes.bool,
  optional: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  success: PropTypes.bool,
  showSuccessIcon: PropTypes.bool,
};

Textarea.defaultProps = {
  label: "",
  placeholder: "",
  showSuccessIcon: true,
};

export default Textarea;
